import { type ExpenseTag } from "@finway-group/shared/lib/models/expense/expenseTag.enum"
import { type ExpenseTagColorEnum } from "@finway-group/shared/lib/models/expense/expenseTagColor.enum"
import { useDispatch } from "react-redux"
import { fetchAllExpenseTags } from "~Shared/store/actions/expenseTag/expenseTagActions"
import { useAttachTagToPurchaseOrderMutation, useCreateTagMutation, useDeleteTagMutation, useDetachTagFromPurchaseOrderMutation } from "../queries/purchaseOrder.queries"

export const useTags = () => {
    const dispatch = useDispatch()

    const { mutate: createTagMutation } = useCreateTagMutation()
    const { mutate: deleteTagMutation } = useDeleteTagMutation()
    const { mutate: attachTagToPurchaseOrder } = useAttachTagToPurchaseOrderMutation()
    const { mutate: detachTagFromPurchaseOrder } = useDetachTagFromPurchaseOrderMutation()

    const deleteTag = async (tagId: string) => {
        await deleteTagMutation(tagId, {
            onSuccess: () => {
                dispatch(fetchAllExpenseTags())
            },
        })
    }

    const createTag = async (tagName: string, tagColor: ExpenseTagColorEnum, opts?: { onSuccess?: (created: ExpenseTag) => void }) => {
        await createTagMutation(
            { tagName, tagColor },
            {
                onSuccess: (created) => {
                    dispatch(fetchAllExpenseTags())
                    opts?.onSuccess?.(created)
                },
            },
        )
    }

    return {
        createTag,
        deleteTag,
        attachTagToPurchaseOrder,
        detachTagFromPurchaseOrder,
    }
}
